module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1AAEB"))).then(() => parcelRequire('2KbAe'));